import React, { ReactNode } from 'react';
import _ from 'lodash';
import parse from "html-react-parser";

import {
  Row,
  Col,
  Offcanvas,
  Modal,
  Button,
} from 'react-bootstrap';
// import styled from 'styled-components';
// import { up, down } from 'styled-breakpoints';

// import { Steps } from "antd";

// Auth
// import { useAuthContext } from '../../../../auth/use-auth-context.js';
// import { useRouter } from '../../../../auth/auth-guard';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector } from '../../../../../utils/store.tsx';
import slice from '../slice.tsx';

import Map from './Map.tsx';

// import {  } from '../../../../../utils/utils.tsx';
// import {  } from '../../../../../utils/enums.tsx';

// import { ReactComponent as XIcon } from "../../../../../../v5/assets/icons/x.svg";

// import {  } from '../../../../manage/jobs/jobTypes/slice.tsx';

// ----------------------------------------------------------------------


const PageComponent = (props: any) => {
  // const { user }: any = useAuthContext();
  // const { userAccount } = user ?? {};
  // const someField = userAccount?.someField;

  // const router = useRouter();

  const { showDriverTrackng, detailsDriverTrackng } = useTypedSelector((state: RootState) => state.jobFormAuditTrailSlice);
  // const { defaultLocations, totalDistance } = useTypedSelector((state: RootState) => state.jobFormSlice);
  const dispatch = useDispatch<AppDispatch>();


  React.useEffect(() => {
    if(showDriverTrackng){
      dispatch(slice.callDriverTrackngApi(detailsDriverTrackng?.jobId, (state: boolean, data: any) => {}));
    }
  }, [showDriverTrackng, detailsDriverTrackng])


  const onCancel = () => {
    dispatch(slice.setShowDriverTrackng({ show: false, details: null }));
  }
  

  const footerElements = () => {
    return <Row className='w-100 gx-12'>
      <Col xs={true}></Col>
      <Col xs={'auto'} className='text-end'>
        <Button
          variant={'custom-text'}
          size={'sm'}
          className='me-12'
          onClick={(e) => {
            onCancel();
          }}
        >Cancel</Button>
      </Col>
    </Row>
  }


  return <Offcanvas
    backdrop={'static'}
    scroll={false}
    placement={'end'}
    show={showDriverTrackng}
    onHide={() => {
      onCancel();
    }}
    style={{ width: '70%' }}
  >
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>
        <div>{detailsDriverTrackng?.updatedDisplay}</div>
        <div className='regular fs-14 gray-600'>{parse(detailsDriverTrackng?.description || '')}</div>
      </Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <Map />
    </Offcanvas.Body>
    <Modal.Footer className='border-top'>{footerElements()}</Modal.Footer>
  </Offcanvas>
}

export default PageComponent;
